/**
 * 招待受諾ページ コンテナ
 */
import type React from "react";
import { useParams } from "react-router-dom";
import { useInvitation } from "../../hooks/useInvitationApi";
import { InvitationPage } from "./InvitationPage";

const InvitationPageContainer: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const { data, loading, error } = useInvitation(token || "");

  return (
    <InvitationPage
      invitation={data}
      loading={loading}
      error={error ? { status: error.status, message: error.message } : null}
      token={token || ""}
    />
  );
};

export default InvitationPageContainer;
